<script setup>
import {computed} from "vue";
import NavigationButtons from "@/components/ai-onboarding/partials/NavigationButtons.vue";
import OptimizerInstallation from "@/components/onsiteOptimizer/installation/OptimizerInstallation.vue";
import useInstallation from "@/composables/optimizer/useOnsiteOptimizer";
import useCompleteOnboarding from "@/composables/ai-onboarding/useCompleteOnboarding";

const {disableContinue} = useInstallation();

const {completeOnboardingMutation, isCompletingOnboarding} = useCompleteOnboarding();
const {mutate: completeOnboarding, isPending} = completeOnboardingMutation;

const isProcessing = computed(() => isPending.value || isCompletingOnboarding.value);
</script>

<template>
  <div class="tw-flex tw-flex-col tw-w-full tw-justify-between tw-h-full">
    <div class="tw-p-18 tw-overflow-y-auto visible-scrollbar">
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-y-6">
        <div class="tw-flex tw-flex-col tw-w-full tw-text-grey-dark">
          <OptimizerInstallation :is-onboarding="true" />
        </div>
      </div>
    </div>
    <NavigationButtons
      :disable-continue="disableContinue"
      :loading="isProcessing"
      :show-back-button="false"
      @next="completeOnboarding()"
    />
  </div>
</template>
